// T3/100A04: reglas puras de acceso por URL (sin React). Usa el MISMO catálogo del menú
// (components/home/tabs.js + submenús de components/home/modules.js) y la MISMA regla de permiso
// (components/home/menu.js:tileAllowed): si el menú no muestra el módulo, la URL tampoco abre.
import { TABS } from "components/home/tabs";
import { submenuInformes, submenuConfigCotizaciones } from "components/home/modules";
import { tileAllowed } from "components/home/menu";

const cleanHref = (href) => String(href || "").split("?")[0].replace(/\/+$/, "");
const isGated = (tile) => [].concat(tile.policy || []).filter(Boolean).length > 0 || Boolean(tile.perm || tile.act);

// href -> mosaicos con permiso que abren esa ruta. Rutas sin permiso ("policy" vacío) no se protegen.
export const buildRouteIndex = (tabs = TABS, submenus = [submenuInformes, submenuConfigCotizaciones]) => {
  const index = new Map();
  const tiles = [...tabs.flatMap((t) => t.modules || []), ...submenus.flat()];
  tiles.forEach((tile) => {
    const href = cleanHref(tile.href);
    if (!href || href === "/" || !isGated(tile)) return;
    index.set(href, [...(index.get(href) || []), tile]);
  });
  return index;
};

// La ruta protegida más larga que contiene a pathname ("/ventas/crm" protege "/ventas/crm/x").
export const matchProtected = (pathname, index) => {
  const path = cleanHref(pathname);
  let best = null;
  index.forEach((tiles, href) => {
    if ((path === href || path.startsWith(`${href}/`)) && (!best || href.length > best.href.length)) best = { href, tiles };
  });
  return best;
};

// "allow" | "deny" | "wait". Superadmin siempre entra (igual que el servidor, REST/permisos/middleware.js:53).
export const routeDecision = ({ pathname, status, superadmin, allow, index }) => {
  const match = matchProtected(pathname, index);
  if (!match) return "allow";
  if (status === "loading") return "wait";
  if (superadmin) return "allow";
  return match.tiles.some((tile) => tileAllowed(tile, allow)) ? "allow" : "deny";
};
